import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AProgress = _resolveComponent("AProgress")!

  return (_openBlock(), _createBlock(_component_AProgress, {
    showInfo: _ctx.showInfo,
    percent: _ctx.percent,
    strokeColor: _ctx.strokeColor,
    status: _ctx.status,
    size: _ctx.size
  }, null, 8, ["showInfo", "percent", "strokeColor", "status", "size"]))
}